import { GET_INVENTORY } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const fetchInventoryDataByNetwork = async (network) => {
  try {
    const resp = await apiClient.get(GET_INVENTORY(network), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
